import Sidebar from "react-sidebar";
import React, { useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import moment from "moment";
import Utils from "../../utility";
import { notificationListService } from "../../services/index";
import { useSelector } from "react-redux";

const SideBarComponent = (props) => {
  const [list, setList] = React.useState([]);
  const userData = useSelector((state) => state?.user?.userDetails?.userDetails?.sub);
console.log(userData, "userdata")
  React.useEffect(() => {
    notificationList();
  }, []);

  const notificationList = async (userData) => {
    const reqObj = {
      queryObj: {
        // userID: "auth0|61d3e76c78b4bd006ac7bf06",
          userID:userData,
          isRead: false,
          isCleared: false,
          title: "Content Report"
      },
      selectionString: {},
    };
    const [err, res] = await Utils.parseResponse(
      notificationListService.notificationDetails(reqObj)
    );
    setList(res);
  };

  return (
    <Drawer style={{ zIndex: 0 }} open={props.isOpen} direction="right">
      <div className="fc-black fs-16 fw-900 p-19">Notifications</div>
      <div className="fc-black" style={{"overflow-y":"scroll", height:"100vh"}}>
        {list?.map((item, index) => {
          return (
            <div>
              <div className="p-t-20 p-l-19 p-l-21 p-t-10">
                {/* <img
                  style={{ height: "35px", width: "35px", cursor: "pointer", borderRadius:"50%" }}
                  src={
                    item?.payload?.user?.photo || "https://tse2.mm.bing.net/th?id=OIP.UaE7CPAUDyWnZEGc_L9MWgHaHa&pid=Api&P=0&w=300&h=300"
                  }
                /> */}
                {/* &nbsp;&nbsp;&nbsp; */}
                <span style={{ cursor: "pointer" }}>
                  {item?.description?.length > 0 ? item?.description : ""}
                </span>
                <br />
                <div className="notify-date">
                  {moment(item?.addedOn).startOf("day").fromNow() || ""}
                  &nbsp;&nbsp;
                </div>
               {item?.length - 1 === index ? "" : <hr className="hr-margin-10"></hr>}
              </div>
            </div>
          );
        })}
        {list?.length === 0 && <div className="p-t-20 p-l-19">No Record</div>}
      </div>
    </Drawer>
  );
};
export default SideBarComponent;
